'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { List } from 'immutable';
import { Fragment } from 'react';
import PropTypes from 'prop-types';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import LegalConsentOptions from 'MeetingsBase/models/LegalConsentOptions';
import LegalConsentFields from 'FormsCommonComponents/LegalConsentFields';
import LegalConsent from 'FormsCommonComponents/lib/LegalConsent';
import { KOALA } from 'HubStyleTokens/colors';
import RecaptchaField from './RecaptchaField';

var LegalConsentInputs = function LegalConsentInputs(_ref) {
  var legalConsentOptions = _ref.legalConsentOptions,
      legalConsentResponses = _ref.legalConsentResponses,
      setGivenConsent = _ref.setGivenConsent,
      recaptchaEnabled = _ref.recaptchaEnabled;
  var previewModel = new LegalConsent(legalConsentOptions.convertToJSON());
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(UITile, {
      style: {
        background: KOALA
      },
      compact: true,
      className: "m-x-10",
      children: /*#__PURE__*/_jsx(UITileSection, {
        className: "p-bottom-0",
        style: {
          wordWrap: 'break-word'
        },
        children: /*#__PURE__*/_jsx(LegalConsentFields, {
          legalConsentRecord: previewModel,
          legalConsentResponses: legalConsentResponses,
          onCommunicationCheckboxChange: setGivenConsent
        })
      })
    }), recaptchaEnabled && /*#__PURE__*/_jsx("div", {
      className: "m-x-10",
      children: /*#__PURE__*/_jsx(RecaptchaField, {})
    })]
  });
};

LegalConsentInputs.propTypes = {
  legalConsentOptions: PropTypes.instanceOf(LegalConsentOptions).isRequired,
  legalConsentResponses: PropTypes.instanceOf(List),
  setGivenConsent: PropTypes.func.isRequired,
  recaptchaEnabled: PropTypes.bool
};
export default LegalConsentInputs;